namespace SorAraBul.Administration {
    export interface UserListRequest extends Serenity.ListRequest {
    }
}
